import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex md:hidden justify-between items-center w-full" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "dark:text-white" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)

import { Button, Icon, Modal } from "@toruslabs/vue-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    open: { type: Boolean, default: false },
    title: { default: "" },
    padding: { type: Boolean, default: true },
    full: { type: Boolean, default: false }
  },
  emits: ["onCloseModal"],
  setup(__props: any, { emit: emits }) {





const closeModal = () => {
  emits("onCloseModal");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    open: _ctx.open,
    classes: {
      overlayContainer: _ctx.full ? '!p-0' : '',
      modalContent: _ctx.full
        ? 'dark:!bg-app-gray-900 dark:!border-0 overflow-y-auto w-full !max-w-none rounded-none md:!max-w-lg md:rounded-[30px]'
        : '!h-fit min-w-[340px] dark:!bg-app-gray-900 dark:!border-0 !rounded-[30px]',
      body: _ctx.padding ? '!py-12 px-8' : '!p-0',
      clearIcon: `!top-4 !right-4 ${_ctx.full ? 'hidden md:block' : ''}`,
      header: 'md:hidden',
    },
    onOnClose: closeModal
  }, _createSlots({
    body: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    (_ctx.full)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(Button), {
                  variant: "text",
                  onOnClick: closeModal
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Icon), {
                      size: "20",
                      name: "chevron-left-icon"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
              _hoisted_4
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["open", "classes"]))
}
}

})